/**
 * Feature flags available in the application
 */
export enum FLAGS {
  NEW_TABLE_VIEWS = 'new-table-views',
  APP_SYNC_ONLY = 'app-sync-only',
  ASSET_TRIPS = 'asset-trips',
  CUSTOM_MAP_TILES = 'custom-map-tiles',
  DAILY_DATA = 'daily-data',
  DATA_HISTORY_SPAN = 'data-history-span',
  ENERGY_TYPE = 'energy-type',
  FAULTS_REPORT = 'faults-report',
  REPORT_A_PROBLEM = 'report-a-problem',
  TYRE_V2 = 'tyre-v2',
  USAGE_REPORT = 'usage-report',
  FUEL_THEFT = 'fuel-theft',
  NEXT_MAINTENANCE = 'gold-next-maintenance',
  CUSTOM_ORGANIZATION_LOGO = 'custom-organization-logo',
  HIBOO_GPT = 'hiboo-gpt',
  HIBOOGPT_MASTRA = 'hiboogpt-mastra',
  RENTAL_CUSTOMER_WORKSPACE = 'poc-rental-customer-workspaces',
  DYNAMIC_WORKSPACE = 'dynamic-workspaces',
  DEVICE_PAIRING = 'device-pairing',
  SSO = 'sso',
  TELTONIKA_OFFSET_SETUP = 'teltonika-offset',
  FILTERS_EXCLUSION = 'filters-exclusion',
  DEV_QR_CODE_DEPLOYMENT = 'dev-qr-code-deployment',
  MAINTENANCE_TASKS_LIST = 'maintenance-tasks-list',
  MAINTENANCE_V2 = 'maintenance-v2',
  TEXT_EDITOR = 'text-editor',
  TEXT_EDITOR_WITH_MENTIONS = 'text-editor-with-mentions',
  WAZE_NAVIGATION = 'waze-navigation',
  ASSET_PROFILE_PICTURE = 'dev-asset-hero-picture',
  DEV_ASSET_FINDER = 'dev-asset-finder',
  DEV_ASSET_FINDER_NEAR_ME = 'dev-asset-finder-near-me',
  DEV_ASSET_FINDER_DESCRIBE = 'dev-asset-finder-describe',
  MIXPANEL_HIBOO = 'mixpanel-hiboo',
  ENERGY_ESTIMATION = 'energy-estimation',
  DEV_THEME_SWITCHER = 'dev-theme-switcher',
  INTEGRATIONS_V2 = 'integrations-v2',
  URGENT_FAULTS_ALERTS = 'urgent-faults-alerts',
  /**
   * Access to pages
   */
  DISPLAY_ALERTS = 'display-alerts',
  DISPLAY_ZONES = 'display-zones',
  USAGE_MODULE_HOME = 'usage-module-home',

  /**
   * Access to module
   */
  LEGACY_MODULE_REPORTS = 'reports', // legacy reports module for old customers
  MODULE_USAGE = 'module-usage',
  MODULE_ENERGY = 'energy',
  MODULE_MAINTENANCE = 'maintenance',
  MODULE_DIAGNOSTICS = 'diagnostics',
  MODULE_EV = 'module-ev',
  MODULE_FIELD = 'bullet-public-page',
  MODULE_INSPECTIONS = 'module-inspections',
  MODULE_CONNECT = 'module-connect',
  IDLE_RATE_ALERTS = 'idle-rate-alerts',
  URGENT_FAULT_ALERTS = 'urgent-faults-alerts',
  MASS_UPDATE_INVENTORY = 'mass-update-inventory',
  PUBLIC_MCP_SERVER = 'public-mcp-server',
  DEV_CONNECTED_APPS = 'dev-connected-apps',
}
